const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M13 14h-2a8.999 8.999 0 0 0-7.968 4.81A10.133 10.133 0 0 1 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11L13 19.5V14Zm-2-2h4v3.308L20.321 11L15 6.692V10h-2a7.982 7.982 0 0 0-6.057 2.774A10.987 10.987 0 0 1 11 12Z\"/>"
};
exports.__esModule = true;
exports.default = data;
